import { takeLatest, put, call } from "redux-saga/effects";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

import {
  FETCH_SCORES_REQUEST,
  FETCH_SCORES_SUCCESS,
  FETCH_SCORES_FAILURE,
  SAVE_SCORE_REQUEST,
  SAVE_SCORE_SUCCESS,
  SAVE_SCORE_FAILURE,
  CHANGE_SCORE_STATUS_REQUEST,
  CHANGE_SCORE_STATUS_SUCCESS,
  CHANGE_SCORE_STATUS_FAILURE,
} from "./actionTypes";

function* fetchScoresSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(
      post,
      process.env.REACT_APP_Fetch_MASTER_SCORE,
      formData
    );

    yield put({ type: FETCH_SCORES_SUCCESS, payload: response });
  } catch (error) {
    console.error("Fetch Scores Error:", error);
    yield put({
      type: FETCH_SCORES_FAILURE,
      payload: error.message,
    });
  }
}

function* saveScoreSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_MASTER_SCORE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save score!");
    }

    yield put({ type: SAVE_SCORE_SUCCESS, payload: response });
    Swal.fire("Success", response.message, "success");
  } catch (error) {
    console.error("Save Score Error:", error);
    yield put({ type: SAVE_SCORE_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

function* changeScoreStatusSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_STATUSCHANGE_MASTER_SCORE,
      action.payload
    );

    const message = response?.message || response?.Msg || response?.msg;
    const isSuccess = response?.status === "Success" || response?.status === "success" || 
                      message?.includes("Successfully") || message?.includes("successfully");

    if (isSuccess) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: message || "Deleted successfully!",
      });
      yield put({ type: CHANGE_SCORE_STATUS_SUCCESS, payload: response });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: message || "Failed to delete score!",
      });
      yield put({ type: CHANGE_SCORE_STATUS_FAILURE, payload: message });
    }
  } catch (error) {
    yield put({ type: CHANGE_SCORE_STATUS_FAILURE, payload: error.message });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message,
    });
  }
}

export default function* scoreMasterSaga() {
  yield takeLatest(FETCH_SCORES_REQUEST, fetchScoresSaga);
  yield takeLatest(SAVE_SCORE_REQUEST, saveScoreSaga);
  yield takeLatest(CHANGE_SCORE_STATUS_REQUEST, changeScoreStatusSaga);
}
